import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getSubPath } from './config/config';

const Languages = ['en', 'hi'];

const subPath = getSubPath(window.location.pathname);


var backendOption;
if (process.env.NODE_ENV === 'development') {
    backendOption = {
        loadPath: `/locales/en/translation.json`,
    };
} else {
    backendOption = {
        loadPath: `${window.location.origin}/${subPath}/locales/en/translation.json`,
    };
}

// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init
i18n
    // load translation using http -> see /public/locales (i.   e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend) // Loads translations using HTTP Requests
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: 'en',
        debug: true,
        whitelist: Languages,
        detection: {
            order: ['queryString', 'cookie'],
            cache: ['cookie'],
        },
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        backend: backendOption,
    });
export default i18n;
